document.addEventListener('DOMContentLoaded', function () {

  const modal = document.querySelector('[data-tachic-size-modal]');
  const openButtons = document.querySelectorAll('[data-tachic-size-open]');
  const closeButtons = document.querySelectorAll('[data-tachic-size-close]');
  const sizeSelect = document.querySelector('[data-tachic-size-select]');
  const unitButtons = document.querySelectorAll('[data-tachic-unit]');

  if (!modal) return;

  let currentUnit = 'in';

  const sizes = {
    XS:{ us:'0-2', bust:[32,33], waist:[24,25], hips:[34,35]},
    S:{ us:'4-6', bust:[34,35], waist:[26,27], hips:[36,37]},
    M:{ us:'8-10', bust:[36,37], waist:[28,29], hips:[38,39]},
    L:{ us:'12-14', bust:[38,40], waist:[30,32], hips:[40,42]},
    XL:{ us:'14-16', bust:[41,43], waist:[33,35], hips:[43,45]}
  };

  function convert(v){
    return currentUnit==='cm' ? Math.round(v*2.54) : v;
  }

  function unit(){
    return currentUnit==='cm' ? 'CM' : 'IN';
  }

  function update(){

    const data=sizes[sizeSelect.value];

    document.querySelector('[data-tachic-fit-note]').textContent=
      'A size '+sizeSelect.value+' will fit someone who typically wears a US '+data.us+'.';

    document.querySelector('[data-bust-min]').innerHTML=convert(data.bust[0])+' <small>'+unit()+'</small>';
    document.querySelector('[data-bust-max]').innerHTML=convert(data.bust[1])+' <small>'+unit()+'</small>';

    document.querySelector('[data-waist-min]').innerHTML=convert(data.waist[0])+' <small>'+unit()+'</small>';
    document.querySelector('[data-waist-max]').innerHTML=convert(data.waist[1])+' <small>'+unit()+'</small>';

    document.querySelector('[data-hips-min]').innerHTML=convert(data.hips[0])+' <small>'+unit()+'</small>';
    document.querySelector('[data-hips-max]').innerHTML=convert(data.hips[1])+' <small>'+unit()+'</small>';

  }

  openButtons.forEach(btn=>{
    btn.addEventListener('click',()=>{
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('tachic-size-no-scroll');
      update();
    });
  });

  closeButtons.forEach(btn=>{
    btn.addEventListener('click',()=>{
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('tachic-size-no-scroll');
    });
  });

  modal.addEventListener('click',function(e){
    if(e.target===modal){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('tachic-size-no-scroll');
    }
  });

  sizeSelect.addEventListener('change',update);

  unitButtons.forEach(btn=>{
    btn.addEventListener('click',function(){

      unitButtons.forEach(b=>b.classList.remove('is-active'));

      this.classList.add('is-active');

      currentUnit=this.dataset.tachicUnit;

      update();

    });
  });

  update();

});